<!-- param: viewMode-控制显示，id-控制数据加载，mode-控制button加载 -->
<template>
  <el-container
    v-loading="loading"
  >
    <!-- 右侧菜单 -->
    <el-container>
      <!-- 功能按钮组 -->
      <el-header height="42px">
        <span v-if="viewMode == 'list'" class="ik-list-title">
          <span class="svg-container ik-list-icon">
            <svg-icon icon-class="database" />
          </span>
          <span>数据列表</span>
        </span>
        <!-- 列表页菜单 -->
        <el-button-group v-if="viewMode === 'list'" class="ik-list-menu">
          <el-button class="ik-list-menu-btn" size="medium" @click="listCreateBtn">新增</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listUpdateBtn">修改</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listDetailsBtn">详情</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listDeleteBtn">删除</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="resetPwd">重置密码</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="resetPassword">修改密码</el-button>
        </el-button-group>
        <!-- 信息页菜单 -->
        <el-button-group v-if="viewMode === 'info'" class="ik-list-menu">
          <!-- 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式 -->
          <el-button v-if="mode == 'edit' || mode == 'details' " class="ik-list-menu-btn" size="medium" @click="infoCreateBtn">新增</el-button>
          <el-button v-if="mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoUpdateBtn">修改</el-button>
          <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoCopyBtn">复制</el-button>
          <el-button v-if="mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoDetailsBtn">详情</el-button>
          <el-button v-if="mode == 'add' || mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoSaveBtn">保存</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="infoCancelBtn">取消</el-button>
        </el-button-group>
      </el-header>
      <el-main>
        <!-- 表头 -->
        <el-form
          v-if="viewMode == 'info'"
          id="ik-info-head"
          v-model="data.head"
          class="ik-info-head"
          :inline="true"
          label-width="120px"
          :disabled="mode == 'details'"
        >
          <el-row>
            <!-- 文本 -->
            <el-col :span="6">
              <ik-form-id
                :ref="'input_id'"
                v-model="data.head['id']"
                code="id"
                name="ID"
                :default-value="0"
                :disabled="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_code'"
                v-model="data.head['code']"
                code="code"
                name="编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_name'"
                v-model="data.head['name']"
                code="name"
                name="名称"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="data.head['stateSign'] === '2'"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_phone'"
                v-model="data.head['phone']"
                code="phone"
                name="联系电话"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="data.head['stateSign'] === '2'"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-image-oss
                :ref="'input_imgPath'"
                v-model="data.head['imgPath']"
                code="imgPath"
                name="头像地址"
                default-value=""
                :disabled="data.head['stateSign'] === '2'"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_sexSign'"
                v-model="data.head['sexSign']"
                code="sexSign"
                name="性别标识"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.sexSign)"
                :disabled="data.head['stateSign'] === '2'"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_pinYinCode'"
                v-model="data.head['pinYinCode']"
                code="pinYinCode"
                name="拼音码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="data.head['stateSign'] === '2'"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="12">
              <ik-form-text
                :ref="'input_content'"
                v-model="data.head['content']"
                code="content"
                name="人员介绍"
                default-value=""
                :min-length="0"
                :max-length="50"
                :disabled="data.head['stateSign'] === '2'"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_doctorTypeSign'"
                v-model="data.head['doctorTypeSign']"
                code="doctorTypeSign"
                name="医生标识"
                default-value="0"
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.doctorTypeSign)"
                :disabled="data.head['stateSign'] === '2'"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_doctorCode'"
                v-model="data.head['doctorCode']"
                code="doctorCode"
                name="医生执业编码"
                default-value=""
                :disabled="data.head['doctorTypeSign'] === '0' || data.head['stateSign'] === '2'"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-image-oss
                :ref="'input_doctorLicense'"
                v-model="data.head['doctorLicense']"
                code="doctorLicense"
                name="医生执业证书"
                default-value=""
                :disabled="data.head['doctorTypeSign'] === '0' || data.head['stateSign'] === '2'"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_doctorSign'"
                v-model="data.head['doctorSign']"
                code="doctorSign"
                name="医生职称标识"
                default-value="1"
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.doctorSign)"
                :disabled="data.head['doctorTypeSign'] === '0' || data.head['stateSign'] === '2'"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_pharmacistTypeSign'"
                v-model="data.head['pharmacistTypeSign']"
                code="pharmacistTypeSign"
                name="药师标识"
                default-value="0"
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.pharmacistTypeSign)"
                :disabled="data.head['stateSign'] === '2'"
                :require="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_pharmacistCode'"
                v-model="data.head['pharmacistCode']"
                code="pharmacistCode"
                name="药师执业编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="data.head['pharmacistTypeSign'] === '0' || data.head['stateSign'] === '2'"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-image-oss
                :ref="'input_pharmacistLicense'"
                v-model="data.head['pharmacistLicense']"
                code="pharmacistLicense"
                name="药师执业证书"
                default-value=""
                :disabled="data.head['pharmacistTypeSign'] === '0' || data.head['stateSign'] === '2'"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_pharmacistSign'"
                v-model="data.head['pharmacistSign']"
                code="pharmacistSign"
                name="药师职称标识"
                default-value="1"
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.pharmacistSign)"
                :disabled="data.head['pharmacistTypeSign'] === '0' || data.head['stateSign'] === '2'"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_stateSign'"
                v-model="data.head['stateSign']"
                code="stateSign"
                name="状态标识"
                default-value="1"
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.stateSign)"
                :disabled="true"
                :require="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询区 -->
        <div class="querybg">
          <el-collapse
            v-if="viewMode == 'list'"
            v-model="searcherActive"
            class="ik-list-searcher"
            accordion
          >
            <el-collapse-item class="ik-list-searcher-item" title="" name="1">
              <!-- 标题栏 -->
              <template slot="title">
                <div class="ik-list-searcher-item-titles">
                  <span class="svg-container ik-list-icon">
                    <svg-icon icon-class="search" />
                  </span>
                  查询条件
                </div>
              </template>
              <!-- 查询菜单 -->
              <el-form
                id="ik-info-head"
                v-model="searcher"
                class="ik-info-head"
                :inline="true"
                label-width="120px"
                :disabled="false"
              >
                <el-row>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_code'"
                      v-model="searcher['code']"
                      code="code"
                      name="编码"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_name'"
                      v-model="searcher['name']"
                      code="name"
                      name="名称"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_phone'"
                      v-model="searcher['phone']"
                      code="phone"
                      name="联系电话"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_sexSign'"
                      v-model="searcher['sexSign']"
                      code="sexSign"
                      name="性别标识"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.sexSign)"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_pinYinCode'"
                      v-model="searcher['pinYinCode']"
                      code="pinYinCode"
                      name="拼音码"
                      default-value=""
                      :min-length="0"
                      :max-length="20"
                      :disabled="false"
                    />
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_doctorTypeSign'"
                      v-model="searcher['doctorTypeSign']"
                      code="doctorTypeSign"
                      name="医生标识"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.doctorTypeSign)"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_doctorSign'"
                      v-model="searcher['doctorSign']"
                      code="doctorSign"
                      name="医生职称标识"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.doctorSign)"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_pharmacistTypeSign'"
                      v-model="searcher['pharmacistTypeSign']"
                      code="pharmacistTypeSign"
                      name="药师标识"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.pharmacistTypeSign)"
                      :disabled="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_pharmacistSign'"
                      v-model="searcher['pharmacistSign']"
                      code="pharmacistSign"
                      name="药师职称标识"
                      default-value=""
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.pharmacistSign)"
                      :disabled="false"
                    />
                  </el-col>
                </el-row>
              </el-form>
              <!-- 操作按钮 -->
              <div class="query-class">
                <div class="query-btn-warp">
                  <el-button type="primary" size="small" @click="searchBtn">查询</el-button>
                  <el-button type="primary" size="small" @click="resetBtn">重置</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 数据表 -->
        <el-table
          v-if="viewMode == 'list'"
          ref="table"
          v-loading="listLoading"
          :data="tableData"
          element-loading-text="加载中..."
          :stripe="true"
          :border="true"
          :fit="true"
          class="ik-list-table"
          height="calc(100% - 50px)"
          :header-row-class-name="'ik-list-table-header-row'"
          :header-cell-class-name="'ik-list-table-header-cell'"
          :row-class-name="'ik-list-table-body-row'"
          :cell-class-name="'ik-list-table-body-cell'"
          :highlight-current-row="true"
          @row-click="rowClick"
        >
          <ik-column-id
            code="id"
            name="ID"
            :edit="false"
          />
          <ik-column-text
            code="code"
            name="编码"
            :edit="false"
          />
          <ik-column-text
            code="name"
            name="名称"
            :edit="false"
          />
          <ik-column-text
            code="phone"
            name="联系电话"
            :edit="false"
          />
          <ik-column-image-oss
            code="imgPath"
            name="头像地址"
            :edit="false"
          />
          <ik-column-select
            code="sexSign"
            name="性别标识"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.sexSign)"
            :edit="false"
          />
          <ik-column-text
            code="pinYinCode"
            name="拼音码"
            :edit="false"
          />
          <ik-column-select
            code="doctorTypeSign"
            name="医生标识"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.doctorTypeSign)"
            :edit="false"
          />
          <ik-column-text
            code="doctorCode"
            name="医生执业编码"
            :edit="false"
          />
          <ik-column-image-oss
            code="doctorLicense"
            name="医生执业证书"
            :edit="false"
          />
          <ik-column-select
            code="doctorSign"
            name="医生职称标识"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.doctorSign)"
            :edit="false"
          />
          <ik-column-select
            code="pharmacistTypeSign"
            name="药师标识"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.pharmacistTypeSign)"
            :edit="false"
          />
          <ik-column-text
            code="pharmacistCode"
            name="药师执业编码"
            :edit="false"
          />
          <ik-column-image-oss
            code="pharmacistLicense"
            name="药师执业证书"
            :edit="false"
          />
          <ik-column-select
            code="pharmacistSign"
            name="药师职称标识"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.pharmacistSign)"
            :edit="false"
          />
          <ik-column-text
            code="content"
            name="人员介绍"
            :edit="false"
          />
          <ik-column-select
            code="stateSign"
            name="状态标识"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.stateSign)"
            :edit="false"
          />
        </el-table>
      </el-main>
      <!-- 分页组件 -->
      <el-footer height="40px">
        <ik-pagination
          v-if="viewMode == 'list'"
          ref="ik_list_pagination"
          :page-no="pagination.pageNo"
          :page-size="pagination.pageSize"
          :total-count="pagination.totalCount"
          @pageChangeMethod="pageChange"
        />
        <el-row v-else class="ik-list-pagination" :gutter="0">
          <el-col :span="6" class="ik-list-enterprise-info" :offset="12">
            <span style="float: left"> 导萃门诊管理系统 </span>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
    <!-- 新增：重置密码弹窗 -->
    <el-dialog
      :visible.sync="passwordDialogVisible"
      title="重置密码"
      width="800px"
      :close-on-click-modal="false"
      :before-close="handlePasswordDialogClose"
    >
      <el-form
        ref="passwordFormRef"
        :model="passwordForm"
        :rules="passwordRules"
        label-width="100px"
        class="password-form"
      >

        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            v-model="passwordForm.oldPassword"
            type="password"
            placeholder="请输入旧密码"
            show-password
            maxlength="20"
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="请输入6-20位新密码"
            show-password
            maxlength="20"
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
            maxlength="20"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="resetPasswordSave">确定</el-button>
      </template>
    </el-dialog>
  </el-container>
</template>
<script>
// 表单组件
import IkFormId from '@/components/ik/form/input/IkFormId'
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormSelect from '@/components/ik/form/input/IkFormSelect'
import IkFormImageOss from '@/components/ik/form/input/IkFormImageOss'
import IkColumnId from '@/components/ik/table/ikColumn/IkColumnId'
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkColumnSelect from '@/components/ik/table/ikColumn/IkColumnSelect'
import IkColumnImageOss from '@/components/ik/table/ikColumn/IkColumnImageOss'
import IkPagination from '@/components/ik/pagination/IkPagination'
import store from '@/store'
import { getById, findPage, save, update, remove } from '@/api/ik/data/dataApi'
import { postData } from '@/api/user/authApi'
export default {
  components: {
    // 表单组件
    IkFormId,
    IkFormText,
    IkFormSelect,
    IkFormImageOss,
    IkColumnId,
    IkColumnText,
    IkColumnSelect,
    IkColumnImageOss,
    IkPagination
  },
  props: {
  },
  data() {
    return {
      // ===== ===== ===== ===== 权限字段 ===== ===== ===== =====
      storeId: store.getters['user/getStoreId'],
      storeCode: store.getters['user/getStoreCode'],
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      bgPath: 'base/user/user/storeuser',
      webPath: 'clinic/store_user',
      jsonStr: {
        stateSign: '[{"key": "1", "value": "未审核"}, {"key": "2", "value": "已审核"}]',
        sexSign: '[{"key": "1", "value": "男"}, {"key": "2", "value": "女"}]',
        doctorTypeSign: '[{"key": "0", "value": "非医生"}, {"key": "1", "value": "医生"}]',
        pharmacistTypeSign: '[{"key": "0", "value": "非药师"}, {"key": "1", "value": "药师"}]',
        pharmacistSign: '[{"key": "1", "value": "非药师"}, {"key": "2", "value": "药士"}, {"key": "3", "value": "药师"}, {"key": "4", "value": "主管药师"}, {"key": "5", "value": "副主任药师"}, {"key": "6", "value": "主任药师"}]',
        doctorSign: '[{"key": "1", "value": "非医生"}, {"key": "2", "value": "医士"}, {"key": "3", "value": "医师"}, {"key": "4", "value": "主治医师"}, {"key": "5", "value": "副主任医师"}, {"key": "6", "value": "主任医师"}]'
      },
      viewMode: '',
      mode: '',
      loading: false,
      listLoading: false,
      dialogVisible: false,
      // ===== ===== ===== ===== 列表页属性 ===== ===== ===== =====
      searcherActive: "0",
      searcher: {},
      tableData: [],
      activeRow: {},
      digData: {
        head: {}
      },
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 1
      },
      // ===== ===== ===== ===== 信息页属性 ===== ===== ===== =====
      id: 0,
      data: {
        head: {},
        body: {}
      },
      bodyMap: [],
      verify: {
        head: {},
        body: {}
      },
      // ===== ===== ===== ===== 新增：重置密码相关 ===== ===== ===== =====
      passwordDialogVisible: false, // 密码弹窗显示状态
      passwordForm: { // 密码表单数据
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: { // 密码表单验证规则
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度需在6-20个字符之间', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    this.viewMode = this.$route.params.viewMode || "list"
    this.mode = this.$route.params.mode || "list"
    this.id = this.$route.query.id || 0
    if (this.mode === "list") {
      this.viewMode = "list"
    } else {
      this.viewMode = "info"
    }
    if (this.viewMode === "list") {
      this.find()
    } else if (this.viewMode === "info") {
      if (this.id !== 0) {
        this.get(this.id)
      }
    }
  },
  methods: {
    // ===== ===== ===== ===== 工具方法 ===== ===== ===== =====
    toJson(jsonStr) {
      return JSON.parse(jsonStr)
    },
    // ===== ===== ===== ===== 工具栏按钮 ===== ===== ===== =====
    listCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    listUpdateBtn() {
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        this.$router.push({ path: '/business/' + this.webPath + '/info/edit', query: { id: $this.activeRow.id }})
      }
    },
    listDetailsBtn() {
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        this.$router.push({ path: '/business/' + this.webPath + '/info/details', query: { id: $this.activeRow.id }})
      }
    },
    listDeleteBtn() {
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要删除的行!'
        })
      } else {
        this.$confirm('删除ID为' + $this.activeRow.id + '的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delete($this.activeRow.id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    infoCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    infoUpdateBtn() {
      this.mode = "edit"
    },
    infoCopyBtn() {
      this.data.head.id = 0
      this.mode = "edit"
    },
    infoDetailsBtn() {
      this.mode = "details"
      this.get(this.data.head.id)
    },
    infoSaveBtn() {
      this.saveOrUpdate()
    },
    infoCancelBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/list/list' })
    },
    searchBtn() {
      this.find()
    },
    resetBtn() {
      this.searcher = {}
      this.find()
    },
    // ===== ===== ===== ===== 列表页表格点击 ===== ===== ===== =====
    rowClick(row, column, event) {
      this.activeRow = row
    },
    onFieldChange(fieldName, oldValue, newValue, errorSign, errorMessage) {
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head' + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
    },
    onBodyFieldChange(line, fieldName, oldValue, newValue, errorSign, errorMessage) {
      this.verify.body['item1' + '-' + line + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', line, fieldName, oldValue, newValue)
    },
    pageChange(pageNo, pageSize) {
      this.pagination.pageNo = pageNo
      this.pagination.pageSize = pageSize
      this.find()
    },
    searchPopupClick(code, row) {
      if (code === "storeCode") {
        this.searcher["storeCode"] = row.code
      }
    },
    headPopupClick(code, row) {
      if (code === "storeCode") {
        this.data.head["storeId"] = row.id
        this.data.head["storeCode"] = row.code
        this.data.head["storeName"] = row.name
      }
    },
    // ===== ===== ===== ===== 接口通讯方法 ===== ===== ===== =====
    saveOrUpdate() {
      const $this = this
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          console.log(this.verify.body[bodyInd])
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      $this.data['head']['storeId'] = $this.storeId
      if ($this.data.head.id) {
        update($this.bgPath, $this.data).then(response => {
          $this.id = response.data
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      } else {
        save($this.bgPath, $this.data).then(response => {
          $this.id = response.data
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      }
    },
    delete(id) {
      const $this = this
      remove($this.bgPath, id).then(response => {
        $this.$message({
          type: 'warning',
          message: '数据已删除!'
        })
        $this.find()
      })
    },
    get(id) {
      const $this = this
      getById($this.bgPath, id).then(response => {
        $this.data = response.data
      })
    },
    find() {
      const $this = this
      $this.listLoading = true
      $this.searcher.storeCode = $this.storeCode
      findPage($this.bgPath, $this.searcher, $this.pagination.pageSize, $this.pagination.pageNo).then(response => {
        $this.tableData = response.data.list
        $this.pagination.totalCount = response.data.totalCount
        $this.listLoading = false
      }).catch(() => {
        $this.listLoading = false
      })
    },
    listOpenBtn() {
      this.dialogVisible = true
      console.log(this.activeRow.id)
      this.digData.head.id = this.activeRow.id
      this.digData.head.code = this.activeRow.code
      this.digData.head.name = this.activeRow.name
      this.digData.head.phone = this.activeRow.phone
      this.digData.head.pinYinCode = this.activeRow.pinYinCode
      this.digData.head.content = this.activeRow.content
    },
    saveDigInfo() {
      const $this = this
      $this.listLoading = true
      update($this.bgPath, $this.digData).then(response => {
        $this.listLoading = false
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已保存!'
        })
      }).catch(() => {
        $this.listLoading = false
      })
    },
    // ===== ===== ===== ===== 新增：重置密码相关方法 ===== ===== ===== =====
    // 验证确认密码
    validateConfirmPassword(rule, value, callback) {
      if (!value) {
        callback(new Error('请确认新密码'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    },
    resetPwd() {
      const $this = this
      if (!$this.activeRow.id) {
        $this.$message({
          type: 'warning',
          message: '请选择需要重置密码的用户!'
        })
        return
      }
      const params = {
        code: $this.activeRow.code
      }
      postData('base/user/user/storeuser/do/resetpassword', params).then(res => {
        $this.$message.success('重置密码成功')
        $this.find()
      })
    },

    // 打开重置密码弹窗
    resetPassword() {
      const $this = this
      // 校验是否选择用户
      if (!$this.activeRow.id) {
        $this.$message({
          type: 'warning',
          message: '请选择需要重置密码的用户!'
        })
        return
      }
      // 重置表单数据和验证状态
      $this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      if ($this.$refs.passwordFormRef) {
        $this.$refs.passwordFormRef.clearValidate()
      }
      // 打开弹窗
      $this.passwordDialogVisible = true
    },
    // 关闭密码弹窗时重置表单
    handlePasswordDialogClose() {
      this.passwordForm = {
        newPassword: '',
        confirmPassword: ''
      }
      if (this.$refs.passwordFormRef) {
        this.$refs.passwordFormRef.clearValidate()
      }
    },
    // 保存重置密码
    resetPasswordSave() {
      const $this = this
      // 表单验证
      $this.$refs.passwordFormRef.validate(async(valid) => {
        if (!valid) {
          $this.$message({
            type: 'error',
            message: '请完善表单信息!'
          })
          return
        }

        try {
          // 构造请求参数
          const params = {
            code: $this.activeRow.code,
            oldPassword: $this.passwordForm.oldPassword,
            newPassword: $this.passwordForm.newPassword
          }
          postData('base/user/user/storeuser/do/updatepassword', params).then(res => {
            $this.$message.success('修改密码成功')
            $this.passwordDialogVisible = false
            $this.find()
          })
        } catch (error) {
          $this.loading = false
          $this.$message({
            type: 'error',
            message: '密码修改失败，请重试!'
          })
          console.error('重置密码失败：', error)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer{position:absolute;right:10px;top:20px;}
</style>
<style lang="scss" >
@import "~@/styles/listinfo.scss";
.data-directory-tabs-info{height:calc(100% - 60px);}
.data-directory-tabs-info .el-tabs__content{height:calc(100% - 53px);overflow:auto;min-height:350px;}
</style>
